
export const RegexPatterns = {
  templateTags: /{{(.+?)}}/g,
  currencies: /{{\s*(LCX:.*?)(?:}}|$)/gi,
  resolve: /{{#resolve}}(.+?){{\/resolve}}/g
};

/**
 * Interpolate any matched tags in the package content.
 * @param pattern
 * @param properties
 * @param item
 */
export function replaceTags(pattern: RegExp, properties: { [index: string]: any }, item: string) {
  return item.replace(pattern, (match, val) => (properties && properties[val.trim()]) ? properties[val.trim()] : '');
}

/**
 * Iterate through package contents and replace any templated strings matching the resolve
 * regex with the actual value appended to its resolverUrl.
 * @param resolverUrl the reolver URL
 * @param item the item within which to resolve the urls
 */
export function resolveUrls(resolverUrl: string, item: string) {
  return item.replace(RegexPatterns.resolve, (match, val) => resolverUrl + val);
}



// WEBPACK FOOTER //
// ./src/helpers/template-utils.ts